import { CarouselArrowStateType, } from '@kubit/web-ui-components/carousel/types';
import { CarouselVariantType } from '../variants';
const COMMON_BUTTON_ICON_STYLES = {
    display: 'flex',
    align_items: 'center',
    position: 'relative',
    cursor: 'pointer',
};
export const getDefaultStyles = (FOUNDATIONS) => {
    const commonArrowSizeStyles = {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    };
    return {
        [CarouselVariantType.DEFAULT]: {
            container: {
                gap: FOUNDATIONS.spacing_250,
            },
            arrowAndCarouselContainer: {
                gap: FOUNDATIONS.spacing_300,
            },
            leftArrowIcon: {
                ...commonArrowSizeStyles,
                color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_icon,
            },
            leftArrowIconDisabled: {
                ...commonArrowSizeStyles,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            rightArrowIcon: {
                ...commonArrowSizeStyles,
                color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_icon,
            },
            rightArrowIconDisabled: {
                ...commonArrowSizeStyles,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            content: {
                gap: FOUNDATIONS.spacing_300,
            },
            pageControlContainer: {
                display: 'flex',
                justify_content: 'center',
                width: '100%',
            },
            [CarouselArrowStateType.DEFAULT]: {
                arrowLeftIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '1px',
                    border_radius: FOUNDATIONS.radius_1000,
                    border_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border,
                    border_style: 'solid',
                },
                arrowRightIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '1px',
                    border_radius: FOUNDATIONS.radius_1000,
                    border_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border,
                    border_style: 'solid',
                },
                arrowLeftIconButtonContainer: COMMON_BUTTON_ICON_STYLES,
                arrowRightIconButtonContainer: COMMON_BUTTON_ICON_STYLES,
            },
            [CarouselArrowStateType.DISABLED]: {
                arrowLeftIconButtonContainer: {
                    ...COMMON_BUTTON_ICON_STYLES,
                    cursor: 'default',
                    border_width: '0px',
                },
                arrowRightIconButtonContainer: {
                    ...COMMON_BUTTON_ICON_STYLES,
                    cursor: 'default',
                    border_width: '0px',
                },
                arrowLeftIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '0',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                arrowRightIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '0',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
            },
            [CarouselArrowStateType.HOVER]: {
                arrowLeftIconButtonContainer: {
                    ...COMMON_BUTTON_ICON_STYLES,
                },
                arrowRightIconButtonContainer: {
                    ...COMMON_BUTTON_ICON_STYLES,
                },
                arrowLeftIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '1px',
                    border_radius: FOUNDATIONS.radius_1000,
                    border_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border,
                    border_style: 'solid',
                    background_color: FOUNDATIONS.color_accent_hover_secondary_bg_50,
                },
                arrowRightIconContainer: {
                    display: 'flex',
                    align_items: 'center',
                    justify_content: 'center',
                    border_width: '1px',
                    border_radius: FOUNDATIONS.radius_1000,
                    border_color: FOUNDATIONS.color_comp_actions_iconbutton_secondaryfilled_default_border,
                    border_style: 'solid',
                    background_color: FOUNDATIONS.color_accent_hover_secondary_bg_50,
                },
            },
            [CarouselArrowStateType.PRESSED]: {
                arrowLeftIconButtonContainer: COMMON_BUTTON_ICON_STYLES,
                arrowRightIconButtonContainer: COMMON_BUTTON_ICON_STYLES,
            },
        },
    };
};
//# sourceMappingURL=default.js.map